import React, { useContext, useEffect, useState } from "react";
import { RtoKpi } from "./Kpi";
import StatewiseChasisRegisted from "./RtoStats/StatewiseChasisRegistered";
import VehicleInsuranceExpiring from "./RtoStats/VehicleInsuranceExpiring";
import RegistrationDetails from "./RtoStats/RegistrationDetails";
import ChasisRegisted from "./RtoStats/ChasisRegistered";
import { FilterContext } from "../../context/Filter";
import Header from "../../components/Header/Header";
import NavButtons from "../../components/NevBar/NavButtons";
import WaterMark from "../../components/WaterMark";

const Rto = () => {
  const [isArn, setIsArn] = useState(null);
  const [isSearchArn, setIsSearchArn] = useState(false);

  // ARN from context (parent or child)
  const { arn: parArn, childArn } = useContext(FilterContext);
  const arn = parArn || childArn;

  // Sync ARN from context
  useEffect(() => {
    if (arn) {
      setIsArn(arn);
      setIsSearchArn(true);
    }
  }, [arn]);

  return (
    <div>
      <WaterMark />
      <Header title="RTO Details" />

      <div className="block md:flex flex-col flex-grow w-96 md:w-full max-w-6xl mx-auto p-2 sm:p-4 min-w-0">
        
        {/* If ARN is missing, show message */}
        {!isArn ? (
          <p className="text-center mt-8 text-gray-600 font-semibold">
            No ARN selected. Please choose an ARN.
          </p>
        ) : (
          <>
            {/* KPI Section */}
            <div className="mb-4">
              <RtoKpi isArn={isArn} />
            </div>

            {/* RTO Stats Grid */}
            <section
              className="grid grid-cols-1 gap-4 
                         md:grid-cols-2 lg:grid-cols-3 
                         mb-4"
            >
              <div className="bg-white rounded-lg shadow-md p-4">
                <VehicleInsuranceExpiring isArn={isArn} />
              </div>

              <div className="bg-white rounded-lg shadow-md p-4">
                <ChasisRegisted isArn={isArn} />
              </div>

              <div
                className="bg-white rounded-lg shadow-md p-4 
                          md:col-span-2 lg:col-span-1"
              >
                <StatewiseChasisRegisted isArn={isArn} />
              </div>
            </section>

            {/* Full width Registration Table */}
            <section className="w-full">
              <div className="bg-white rounded-lg shadow-md p-4">
                <RegistrationDetails isArn={isArn} />
              </div>
            </section>
          </>
        )}
      </div>

      {/* Bottom Nav Buttons */}
      <div className="sticky bottom-0 w-full z-10">
        <NavButtons />
      </div>
    </div>
  );
};

export default Rto;
